import { useState, useEffect } from 'react';
import { Box, Typography, CircularProgress, styled, Button, IconButton } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import RestartAltIcon from '@mui/icons-material/RestartAlt';

const OverlayContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  background: theme.palette.grey[300],
  padding: '1rem',
  gap: '1rem',
}));

export const TrainingModuleEndingOverlay = ({
  handleRestartVideo,
  hasNext,
  trainingCompleted,
  nextVideo,
}) => {
  const [progress, setProgress] = useState(100);

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((prevProgress) => (prevProgress <= 0 ? 0 : prevProgress - 10));
    }, 1000);

    setTimeout(() => {
      nextVideo();
    }, 10000);

    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <OverlayContainer>
      {hasNext ? (
        <>
          <Box sx={{ position: 'relative', display: 'inline-flex' }}>
            <CircularProgress variant="determinate" value={progress} />
            <Box
              sx={{
                top: 0,
                left: 0,
                bottom: 0,
                right: 0,
                position: 'absolute',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Typography variant="caption" component="div">
                {`${Math.round(progress / 10)}s`}
              </Typography>
            </Box>
          </Box>
          <Typography variant="body1" textAlign="center">
            The next video will autoplay after 10 seconds.
          </Typography>
          <IconButton onClick={handleRestartVideo} aria-label="restart video">
            <RestartAltIcon />
          </IconButton>
        </>
      ) : (
        <>
          <CheckCircleOutlineIcon fontSize="large" sx={{ color: 'success.main' }} />
          {trainingCompleted ? (
            <Box
              sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '1rem' }}
            >
              <Typography variant="body1" textAlign="center">
                Thank you for reviewing this training.
              </Typography>
              <IconButton onClick={handleRestartVideo} aria-label="restart video">
                <RestartAltIcon />
              </IconButton>
            </Box>
          ) : (
            <Box
              sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '1rem' }}
            >
              <Typography variant="body1" textAlign="center">
                Thank you for completing this training! Please click the button below to confirm
                completion.
              </Typography>
              <IconButton onClick={handleRestartVideo} aria-label="restart video">
                <RestartAltIcon />
              </IconButton>
            </Box>
          )}
        </>
      )}
    </OverlayContainer>
  );
};
